var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SuccessMessageModal',{attrs:{"message":'Your wallet has been funded successfully',"button-action":_vm.closeModal,"is-open":_vm.openSuccess,"cancel":_vm.closeModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }